import Factory from '../utils/factory'

export default Factory({
  from: null,
  to: null,
  domain: null,
  redirectUrl: null,
})
